import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { addLotto, resetLottoCaricatoAction, setDataFine, setDataInizio } from "./actions";
import { NuovaCampagnaReducerType } from "./types";

const initialState: NuovaCampagnaReducerType = {
  lottoCaricato: undefined,
  dataInizio: moment().toDate(),
  dataFine: moment().add('7', 'days').toDate()
}

export const nuovaCampagnaReducer = createReducer(initialState, (builder) => {

  builder
    .addCase(addLotto.pending, (state) => {
      state.lottoCaricato = initialState.lottoCaricato;
    })
    .addCase(addLotto.fulfilled, (state, action) => {
      state.lottoCaricato = action.payload;
    })
    .addCase(resetLottoCaricatoAction, (state) => {
      state.lottoCaricato = initialState.lottoCaricato;
    })
    .addCase(setDataInizio, (state, action) => {
      state.dataInizio = action.payload;
    })
    .addCase(setDataFine, (state, action) => {
      state.dataFine = action.payload;
    })
});
